import React from 'react';
import { motion } from 'framer-motion';
import { experience } from '../mock';

const Experience = () => {
  return (
    <section id="experience" className="relative py-32 bg-background">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-16">
        
        {/* Sticky Left Sidebar */}
        <div className="lg:col-span-4 relative">
          <div className="sticky top-32">
            <span className="mono text-xs uppercase tracking-widest text-primary mb-4 block">// Career</span>
            <h2 className="serif text-5xl sm:text-6xl text-white mb-6 leading-tight">
              A history of <br />
              <span className="italic text-slate-500">resilience</span>
            </h2>
            <p className="text-slate-400 font-light text-sm">
              From hands-on systems engineering to leading regional cloud transformations, every chapter has sharpened the same craft: building things that don't break at 3 AM.
            </p>
          </div>
        </div>

        {/* Scrollable Right Content */}
        <div className="lg:col-span-8">
          <div className="space-y-24">
            {experience.map((exp, idx) => (
              <motion.div 
                key={idx}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8 }}
                className="relative pl-8 md:pl-12 border-l border-white/10"
              >
                {/* Timeline Dot */}
                <div className="absolute left-[-5px] top-2 w-2 h-2 rounded-full bg-primary" />
                <div className="absolute left-[-17px] top-[-1px] w-8 h-8 rounded-full border border-primary/30 opacity-0 hover:opacity-100 transition-opacity" />

                <div className="flex flex-col md:flex-row md:items-baseline justify-between mb-2">
                  <h3 className="serif text-3xl text-white group-hover:text-primary transition-colors">
                    {exp.role}
                  </h3>
                  <span className="mono text-xs uppercase tracking-widest text-primary mt-2 md:mt-0 shrink-0">
                    {exp.period}
                  </span>
                </div>
                
                <div className="text-sm font-medium text-slate-300 mb-6 uppercase tracking-wide">
                  {exp.company} <span className="text-slate-600 mx-2">|</span> {exp.location}
                </div>

                <p className="text-slate-400 font-light mb-6">
                  {exp.summary}
                </p>

                <ul className="space-y-3">
                  {exp.points.map((pt, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm text-slate-500">
                      <span className="mt-1.5 w-1 h-1 rounded-full bg-slate-700 shrink-0" />
                      <span>{pt}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
        
      </div>
    </section>
  );
};

export default Experience;
